<template>
  <div class="bb-circle-checkbox">
    <span class="bb-circle-checkbox__contour"/>
    <input class="bb-circle-checkbox__input" type="checkbox" v-model="checked" :disabled="disabled"/>
    <i class="bb-circle-checkbox__icon icon-check-circle"/>
  </div>
</template>

<script>
export default {
  name: 'CircleCheckbox',
  props: ['value', 'item', 'disabled'],
  computed: {
    checked: {
      get: function () {
        return this.value
      },
      set: function (data) {
        this.$emit('change', data, this.item)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";

  .bb-circle-checkbox {
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    cursor: pointer;
    line-height: 1;

    &__input {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      margin: 0;
      opacity: 0;
      cursor: pointer;

      &:disabled {
        cursor: default;
        pointer-events: none;
      }

      &:checked + i {
        top: 0;
        left: 0;
        transform: scale(1);
      }
    }

    &__contour {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border: 1px solid $color-japanese-laurel;
      box-sizing: border-box;
      border-radius: 50%;
    }

    &__icon {
      top: calc(50% - 8px);
      left: calc(50% - 8px);
      font-size: 16px;
      color: $color-japanese-laurel;
      transition: 0.1s ease;
      pointer-events: none;
      transform: scale(0);

      &:before {
        margin: 0;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/Inputs/CircleCheckbox.vue